import React from 'react';
import classnames from 'classnames';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import './PageTabs.scss';

const PageTabs = props => (
  <ul className="page-tabs">
    {props.data.map(menu => {
      const menuStyles = classnames({
        'page-tabs__menu': true,
        'page-tabs__menu--on': menu.key === props.pickedMenu,
      });
      return (
        <li key={menu.key} className={menuStyles}>
          <NavLink to={menu.link} onClick={menu.onClick} catetory={menu.key}>
            {menu.name}
          </NavLink>
        </li>
      );
    })}
  </ul>
);

PageTabs.propTypes = {
  data: PropTypes.array.isRequired,
};

export default PageTabs;
